import ActionType from 'actions/ActionType'
import steps from 'components/Onboarding/steps'
import stepService from 'components/Onboarding/stepService'

export default (state = { completed: {}, expanded: true }, action) => {
  switch (action.type) {
    case ActionType.Onboarding.READ_SUCCESS:
      const completed = {}
      if (action.payload.incomplete_steps) {
        steps.forEach((step, i) => {
          if (
            typeof action.payload.incomplete_steps.find(
              incStep =>
                (stepService[i] || 'Unknown').indexOf(incStep.description) > -1
            ) === 'undefined'
          ) {
            completed[i] = true
          }
        })
      }
      return {
        ...state,
        ...action.payload,
        completed,
      }
    case ActionType.Onboarding.TOGGLE_EXPANSION_PANEL:
      return {
        ...state,
        expanded: action.payload !== null ? action.payload : !state.expanded,
      }
    default:
      return state
  }
}
